// extracted by mini-css-extract-plugin
export default {"contact":"Contact_contact__xKAT9","contactInfo":"Contact_contactInfo__qGzUy","map":"Contact_map__+W-hk","btnSecondary":"Contact_btnSecondary__r7Y55"};